const CsvDownloadSection = () => {
  return (
    <section className="relative py-16 sm:py-24 lg:py-32 bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8">
          <div className="flex items-center justify-center order-2 lg:order-1">
            <img
              src="/download-csv-feature.png"
              alt="CSV Download Feature"
              className="rounded-lg shadow-xl max-w-[75%] h-auto"
            />
          </div>
          <div className="flex flex-col justify-center order-1 lg:order-2">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Easy CSV Data Export
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Streamline your workflow with our powerful CSV export functionality. Download and manage your data with ease.
            </p>
            <ul className="mt-8 space-y-4 text-gray-600">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Export transcript data in standardized CSV format
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Compatible with all major spreadsheet software
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Bulk export capabilities for multiple transcripts
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                Customizable data fields to match your needs
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CsvDownloadSection;
